import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnLoading as CnLoadingFC } from './loading';
import { hide, show } from './loading-toast';
import './index.scss';
// @ts-ignore
const CnLoading = withI18n(CnLoadingFC, {
    locale,
    _noHoc: true,
});
CnLoading.show = show;
CnLoading.hide = hide;
export { CnLoading };
